import moment from 'moment';
import { timeAndPrecisionTypes } from 'smartsuite-ui';
import { dateTimeFormat } from '../../shared/constants/constants';

export function getFixedRangeStartAndEnd(
    { startDateTime, endDateTime },
    format = dateTimeFormat
) {
    return {
        start: moment(startDateTime).format(format),
        end: moment(endDateTime).format(format),
    };
}

export function getFixedDayStartAndEnd(
    { startDateTime },
    format = dateTimeFormat
) {
    return {
        start: moment(startDateTime).startOf('day').format(format),
        end: moment(startDateTime).add(1, 'day').format(format),
    };
}

export function getLastStartAndEnd(
    { rangeType, rangeValue },
    currentTime,
    format = dateTimeFormat
) {
    return {
        start: moment(currentTime)
            .add(-1 * rangeValue, rangeType)
            .format(format),
        end: moment(currentTime).format(format),
    };
}

export function getNextStartAndEnd(
    { rangeType, rangeValue },
    currentTime,
    format = dateTimeFormat
) {
    return {
        start: moment(currentTime).format(format),
        end: moment(currentTime).add(rangeValue, rangeType).format(format),
    };
}

export function getPredefinedStartAndEnd(
    timeAndPrecision,
    currentTime,
    format = dateTimeFormat
) {
    const { predefinedType, predefinedValue, predefinedLength } =
        timeAndPrecision;

    const start = moment(currentTime)
        .add(predefinedValue, predefinedType)
        .startOf(predefinedType)
        .format(format);

    return {
        start,
        end: moment(start)
            .add(predefinedLength, predefinedType)
            .startOf(predefinedType)
            .format(format),
    };
}

/* eslint-disable complexity */
export function getDateTimeRangeStartAndEnd(
    timeAndPrecision,
    currentTime = moment(),
    format = dateTimeFormat
) {
    switch (timeAndPrecision.timeAndPrecisionType) {
        case timeAndPrecisionTypes.fixed: {
            return getFixedRangeStartAndEnd(timeAndPrecision, format);
        }

        case timeAndPrecisionTypes.fixedDay: {
            return getFixedDayStartAndEnd(timeAndPrecision, format);
        }

        case timeAndPrecisionTypes.last: {
            return getLastStartAndEnd(timeAndPrecision, currentTime, format);
        }

        case timeAndPrecisionTypes.next: {
            return getNextStartAndEnd(timeAndPrecision, currentTime, format);
        }

        case timeAndPrecisionTypes.predefined: {
            return getPredefinedStartAndEnd(
                timeAndPrecision,
                currentTime,
                format
            );
        }

        default:
            throw Error(
                `getFormattedDateTimeRange - timeAndPrecisionType not implemented: ${timeAndPrecision.timeAndPrecisionType}`
            );
    }
}
/* eslint-enable complexity */

export function getFormattedDateRangeString(
    timeAndPrecision,
    currentTime = moment(),
    format = dateTimeFormat
) {
    const startAndEnd = getDateTimeRangeStartAndEnd(
        timeAndPrecision,
        currentTime,
        format
    );

    return `${startAndEnd.start} - ${startAndEnd.end}`;
}
